import { FormLabel, FormControlLabel, styled } from '@mui/material';

export const StyledFormLabel = styled(FormLabel)`
  font-size: 12px;
`;

export const StyledFormControlLabel = styled(FormControlLabel)`
  height: 24px;
`;
